import { applyCardFilters } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/applyCardFilters'
import type { CardFilterValues } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsCardView/documentCardFilterBar/types'
import type { DocumentTableRow } from 'features/knowledgeDocumentViewer/components/advancedSearch/components/documentsTableView/DocumentTableColumns'
import { cardFiltersToSyncedColumnFilters } from 'features/knowledgeDocumentViewer/components/advancedSearch/hooks/useDocumentSearchResultFilters'
import {
  type DocumentSearchResult,
  getDocumentSearchWeights,
} from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'
import type { DocSearchSelectPowerAnalyticsProperties } from 'features/knowledgeDocumentViewer/hooks/usePowerAnalyticsBackend'
import { urlSearchParamsFromColumnFilters } from 'routes/documents/-searchParams'

export function getDocumentSearchMeta(
  documentId: string,
  rawSearchData: DocumentSearchResult | undefined
): { source: string; score: number } | undefined {
  const result = rawSearchData?.results.find(
    (r) => r.document_id === documentId
  )
  if (!result) return undefined
  return { source: result.sources.join('+'), score: result.score }
}

export function buildDocSearchSelectPayload({
  doc,
  documentResults,
  cardFilters,
  rawSearchData,
  query,
  siteId,
  openInNewTab,
  isLinkedDocsMode,
}: {
  doc: DocumentTableRow
  documentResults: DocumentTableRow[]
  cardFilters: CardFilterValues
  rawSearchData: DocumentSearchResult | undefined
  query: string
  siteId: string
  openInNewTab: boolean
  isLinkedDocsMode: boolean
}): DocSearchSelectPowerAnalyticsProperties {
  const filteredList = applyCardFilters(documentResults, cardFilters)
  const unfilteredIdx = documentResults.findIndex((d) => d.id === doc.id)
  const filteredIdx = filteredList.findIndex((d) => d.id === doc.id)
  const rank_unfiltered = unfilteredIdx >= 0 ? unfilteredIdx + 1 : 0
  const rank_filtered = filteredIdx >= 0 ? filteredIdx + 1 : 0
  const meta = getDocumentSearchMeta(doc.id, rawSearchData)
  const weights = getDocumentSearchWeights(rawSearchData)

  return {
    document_id: doc.id,
    rank_unfiltered,
    rank_filtered,
    source: meta?.source,
    score: meta?.score,
    lexical_weight: weights?.lexical_weight,
    semantic_weight: weights?.semantic_weight,
    query,
    site_id: siteId,
    open_in_new_tab: openInNewTab,
    is_linked_docs_mode: isLinkedDocsMode,
    ...urlSearchParamsFromColumnFilters(
      cardFiltersToSyncedColumnFilters(cardFilters)
    ),
  }
}
